import { DESKTOP_SIDEBAR_COLLAPSED_WIDTH } from "../../components/header/header_styled_components";

export interface DesktopSidebarOffsetOptions {
	isSidebarCollapsed: boolean;
	// Callers gate the sidebar's visibility on their own breakpoint/auth/menu checks and
	// may not have all three; each defaults to true so a call site can omit whichever it
	// doesn't track (e.g. a component that only ever renders on desktop can skip isDesktop).
	isDesktop?: boolean;
	isAuthenticated?: boolean;
	appMenuVisible?: boolean;
}

// Whether the desktop sidebar (rail or panel) is currently on screen at all. This is a
// boolean, not a width — the sidebar's actual on-screen width varies continuously between
// the collapsed rail and the expanded panel (see `getDesktopSidebarOffsetCss`, which tracks
// the live `--app-sidebar-width` CSS var). Anything that needs the exact current width to
// clear the sidebar must use that CSS-based helper instead; this one only answers "is it
// there", e.g. for toggling a body class.
export const isDesktopSidebarShown = ({
	isDesktop = true,
	isAuthenticated = true,
	appMenuVisible = true,
}: DesktopSidebarOffsetOptions): boolean => isDesktop && isAuthenticated && appMenuVisible;

export const getDesktopSidebarOffsetCss = (options: DesktopSidebarOffsetOptions): string => {
	if (!isDesktopSidebarShown(options)) return "0px";
	return options.isSidebarCollapsed
		? `${DESKTOP_SIDEBAR_COLLAPSED_WIDTH}px`
		: "var(--app-sidebar-width, 248px)";
};
